<template>
  <div class="szw-row__between szw-rounded szw-px-2 szw-py-3 szw-bg-section-static szw-text-xs szw-h-[41px]">
    <table-header-skeleton v-if="status === 'loading'" :headerCells="props.headerCells" />

    <template v-else>
      <span v-for="(cell, index) of props.headerCells" :class="[getCellClasses(cell, index), { 'szw-custom-cell': isDefaultHighlighted }]" :key="cell">
        {{ loc(cell || '', langId) }}
      </span>
      <team-form-cell v-if="hasTeamFormCell" />
    </template>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import TableHeaderSkeleton from './TableHeaderSkeleton.vue'
import TeamFormCell from './TeamFormCell.vue'
import { loc } from '@/__core__/localization/localization'

const props = defineProps({
  headerCells: {
    type: Array,
    default: () => []
  },
  highlightedCells: {
    type: Array,
    default: () => []
  },
  customCellConf: {
    type: Object,
    default: () => {}
  },
  hasTeamFormCell: {
    type: Boolean,
    default: () => false
  }
})

const status = inject('status')
const langId = inject('langId', '')

const isSmallWidgetContainerSize = inject('isSmallWidgetContainerSize')
const isDefaultHighlighted = computed(() => props.highlightedCells.length === 0)

/**
 * @param {String} cell
 * @param {Number} index
 **/
const getCellClasses = (cell, index) => {
  let highlightClass = ''

  if (props.highlightedCells.includes(index)) {
    highlightClass = 'szw-font-semibold'
  }

  const customClass = props.customCellConf?.[index] || '';

  const isDefault = isSmallWidgetContainerSize?.value === undefined ? true : isSmallWidgetContainerSize?.value
  if (status.value === 'success') {
    return `${isDefault ? 'szw-min-w-8' : 'szw-min-w-9'} szw-text-center first:szw-mr-auto first:szw-text-left ${highlightClass} ${customClass}`
  } else {
    return ''
  }
}
</script>

<style>
.szw-custom-cell:last-of-type {
  font-weight: 600;
}
</style>
